import {useTranslation} from 'react-i18next';

const useFieldsProviderApplicationInitial = () => {
    const {t} = useTranslation();

    return {
        valid: false,
        fields: {
            title: {
                value: '',
                name: 'title',
                APIField: 'title',
                required: true,
                rules: [
                    {
                        type: 'notEmpty'
                    },
                    {
                        type: 'atLeastOneDigitOrLetter'
                    },
                    {
                        type: 'noRepeatingSpaces'
                    },
                    {
                        type: 'maxLength',
                        length: 56
                    }

                ],
                validate: true,
                valid: false,
                touched: false,
                errors: [],
            },
            industry: {
                value: '',
                name: 'industry',
                APIField: 'industry_id',
                required: true,
                rules: [
                    {
                        type: 'notEmpty'
                    }
                ],
                config: {
                    options: []
                },
                validate: true,
                valid: false,
                touched: false,
                errors: [],
            },
            // emailReports: {
            //     value: '',
            //     name: 'emailReports',
            //     name: 'email',
            //     validate: true,
            //     rules: [
            //         {
            //             type: 'isEmail'
            //         },
            //         {
            //             type: 'validOnEmpty'
            //         }
            //     ],
            //     valid: true,
            //     touched: false,
            //     errors: [],
            //     errorsFragment: []
            // },
            emailPublic: {
                value: '',
                name: 'emailPublic',
                validate: true,
                required: true,
                rules: [
                    {
                        type: 'isEmail'
                    }
                ],
                valid: false,
                touched: false,
                errors: [],
            },
            receiveReports: {
                value: true,
                name: 'receiveReports',
                validate: true,
                required: false,
                rules: [
                ],
                valid: true,
                touched: false,
                errors: [],
            },
            phone: {
                value: '',
                name: 'phone',
                validate: true,
                required: false,
                rules: [
                    {
                        type: 'isNumeric'
                    },
                    {
                        type: 'validOnEmpty'
                    },
                    {
                        type: 'maxLength',
                        length: 64
                    }
                ],
                valid: true,
                touched: false,
                errors: [],
            },
            website: {
                value: '',
                name: 'website',
                validate: true,
                required: false,
                rules: [
                    {
                        type: 'atLeastOneDigitOrLetter'
                    },
                    {
                        type: 'noRepeatingSpaces'
                    },
                    {
                        type: 'isURL'
                    },
                    {
                        type: 'validOnEmpty'
                    },
                ],
                valid: true,
                touched: false,
                errors: [],
            },
            country: {
                value: [],
                name: 'country',
                required: true,
                rules: [
                    {
                        type: 'notEmpty'
                    }
                ],
                config: {
                    options: []
                },
                validate: true,
                valid: false,
                touched: false,
                errors: [],
            },
            descriptionShort: {
                value: '',
                name: 'descriptionShort',
                validate: true,
                required: true,
                rules: [
                    {
                        type: 'notEmpty'
                    },
                    {
                        type: 'maxLength',
                        length: 128
                    },
                    {
                        type: 'atLeastOneDigitOrLetter'
                    },
                    {
                        type: 'noRepeatingSpaces'
                    },
                ],
                valid: false,
                touched: false,
                errors: [],
            },
            descriptionFull: {
                value: '',
                name: 'descriptionFull',
                validate: true,
                required: false,
                rules: [
                    {
                        type: 'maxLength',
                        length: 255
                    },
                    {
                        type: 'noRepeatingSpaces'
                    },
                    {
                        type: 'atLeastOneDigitOrLetter'
                    },
                    {
                        type: 'validOnEmpty'
                    },
                ],
                valid: true,
                touched: false,
                errors: [],
            },
            logoImage: {
                value: [],
                name: 'logoImage',
                validate: true,
                required: false,
                rules: [
                    {
                        type: 'fileMaxSizeMB',
                        value: 2
                    },
                    {
                        type: 'validOnEmpty'
                    }
                ],
                valid: true,
                touched: false,
                errors: [],
            },
            confirmTOS: {
                value: false,
                name: 'confirmTOS',
                validate: true,
                required: true,
                rules: [
                    {
                        type: 'isEqual',
                        equalTo: true,
                        customMessage: () => t('ProviderApplication.tos-feedback-error')
                    }
                ],
                valid: false,
                touched: false,
                errors: [],
            },
            socialFacebook: {
                value: '',
                name: 'socialFacebook',
                validate: true,
                required: false,
                rules: [
                    {
                        type: 'maxLength',
                        length: 128
                    },
                    {
                        type: 'atLeastOneDigitOrLetter'
                    },
                    {
                        type: 'noSpaces'
                    },
                    {
                        type: 'validOnEmpty'
                    },

                ],
                valid: true,
                touched: false,
                errors: [],
                errorsFragment: []
            },
            socialTwitter: {
                value: '',
                name: 'socialTwitter',
                validate: true,
                required: false,
                rules: [
                    {
                        type: 'maxLength',
                        length: 128
                    },
                    {
                        type: 'atLeastOneDigitOrLetter'
                    },
                    {
                        type: 'noSpaces'
                    },
                    {
                        type: 'validOnEmpty'
                    },
                ],
                valid: true,
                touched: false,
                errors: [],
                errorsFragment: []
            },
            socialLinkedInProfile: {
                value: '',
                name: 'socialLinkedInProfile',
                validate: true,
                required: false,
                rules: [
                    {
                        type: 'maxLength',
                        length: 128
                    },
                    {
                        type: 'atLeastOneDigitOrLetter'
                    },
                    {
                        type: 'noSpaces'
                    },
                    {
                        type: 'validOnEmpty'
                    },
                ],
                valid: true,
                touched: false,
                errors: [],
                errorsFragment: []
            },
            // socialLinkedInCompany: {
            //     value: '',
            //     name: 'socialLinkedInCompany',
            //     validate: true,
            //     rules: [
            //         {
            //             type: 'maxLength',
            //             length: 128
            //         },
            //         {
            //             type: 'atLeastOneDigitOrLetter'
            //         },
            //         {
            //             type: 'noRepeatingSpaces'
            //         }, 
            //         {
            //             type: 'validOnEmpty'
            //         },
            //     ],
            //     valid: false,
            //     touched: false,
            //     errors: [],
            //     errorsFragment: []
            // },
            socialInstagram: {
                value: '',
                name: 'socialInstagram',
                validate: true,
                required: false,
                rules: [
                    {
                        type: 'maxLength',
                        length: 128
                    },
                    {
                        type: 'atLeastOneDigitOrLetter'
                    },
                    {
                        type: 'noSpaces'
                    },
                    {
                        type: 'validOnEmpty'
                    },
                ],
                valid: true,
                touched: false,
                errors: [],
                errorsFragment: []
            }
        }
    }
}

export default useFieldsProviderApplicationInitial;
